/**
* SurveyCompleteByOfferIdController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';SurveyCompleteByOfferIdController.$inject = ["$rootScope", "$state", "$stateParams", "$localStorage", "$window"];

  angular.
  module('gplans.survey.controllers').
  controller('SurveyCompleteByOfferIdController', SurveyCompleteByOfferIdController);

  SurveyCompleteByOfferIdController.$inject = ['$rootScope', '$state', '$stateParams', '$localStorage', '$window'];

  /**
                                                                                                                    * @namespace SurveyCompleteByOfferIdController
                                                                                                                    */
  function SurveyCompleteByOfferIdController($rootScope, $state, $stateParams, $localStorage, $window) {
    activate();

    /**
                * @name activate
                * @desc Actions to be performed when this controller is instantiated
                * @memberOf gplans.survey.controllers.SurveyCompleteByOfferIdController
                */
    function activate() {
      $window.localStorage.offerId = $stateParams.offerId;
      $rootScope.offerId = $stateParams.offerId;
      $state.go('base.complete', { userSurvey: $localStorage['userSurvey'] });
    }
  }
})();